import { render } from "./DesignGlass.vue?vue&type=template&id=09042f5a&scoped=true"
import script from "./DesignGlass.vue?vue&type=script&lang=js"
export * from "./DesignGlass.vue?vue&type=script&lang=js"

import "./DesignGlass.vue?vue&type=style&index=0&id=09042f5a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09042f5a"]])

export default __exports__